export function generateSCORMHtmlContent(name, frontendURL, sequencePath) {
  console.log("sequenceName", name);
  return `
<!DOCTYPE html>
<html lang="fr">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>${name}</title>
  <style>
    html, body {
      height: 100%;
      margin: 0;
      padding: 0;
    }
    body {
      display: flex;
      flex-direction: column;
    }
    iframe {
      flex-grow: 1;
      border: none;
    }
  </style>
</head>
<script>
function findAPI(win) {
    while ((win.API == null) && (win.parent != null) && (win.parent != win)) {
        win = win.parent;
    }
    return win.API;
}

function getAPI() {
    let api = findAPI(window);
    if (api == null && window.opener != null && typeof(window.opener) != "undefined") {
        api = findAPI(window.opener);
    }
    return api;
}

const scormAPI = getAPI();
let moodleParams = "";
if (scormAPI) {
    // Initialiser la session SCORM
    scormAPI.LMSInitialize("");
    
    // Récupérer l'ID et le nom de l'utilisateur connecté
    const learnerId = scormAPI.LMSGetValue("cmi.core.student_id");
    const learnerName = scormAPI.LMSGetValue("cmi.core.student_name");
    console.log("SCORM : ID de l'utilisateur:", learnerId);
    console.log("SCORM : learnerName", learnerName);

    const firstname = learnerName;
    const lastname = "SCORM (id: " + learnerId + ")"
    
    // Générer les paramètres Moodle
    moodleParams = "&firstname=" + firstname + "&lastname=" + lastname;

    console.log("SCORM : lastname, firstname, moodleParams", lastname, firstname, moodleParams);
}

// Ajouter les paramètres à l'URL de l'iframe
document.addEventListener('DOMContentLoaded', function () {
    const iframe = document.getElementById('scorm-content');
    iframe.src = "${frontendURL}${sequencePath}" + moodleParams;
});

window.addEventListener('message', function(event) {
  // Vérifie l'origine pour être sûr qu'elle vient de ton frontend
  if (event.origin !== "${frontendURL}") {
    console.error("Message non autorisé depuis une origine inconnue :", event.origin);
    return;
  }
  if (event.data.type === 'sequenceCompleted') {
    console.log("Message reçu: Séquence terminée");
    const score = event.data.score;

    // Définir le score
    scormAPI.LMSSetValue("cmi.core.score.raw", score.toString());

    // Marquer la leçon comme terminée
    /*
    if (score >= 70) { // Si tu as un seuil de réussite de 70
      scormAPI.LMSSetValue("cmi.core.lesson_status", "passed");
    } else {
      scormAPI.LMSSetValue("cmi.core.lesson_status", "failed");
    }
    */

    // Commit et terminer la session SCORM
    scormAPI.LMSCommit("");
    scormAPI.LMSFinish(""); // Indique que la tentative est terminée
  }
}, false);

</script>
<body>
  <iframe id="scorm-content" width="100%" height="100%" frameborder="0"></iframe>
</body>
</html>
`;
}

export function generateSCORMImsManifestContent(name) {
  return `<?xml version="1.0" encoding="UTF-8"?>
<manifest identifier="com.example.scorm" version="1" xmlns="http://www.imsglobal.org/xsd/imscp_v1p1"
          xmlns:adlcp="http://www.adlnet.org/xsd/adlcp_v1p3"
          xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
          xsi:schemaLocation="http://www.imsglobal.org/xsd/imscp_v1p1 imscp_v1p1.xsd 
                              http://www.adlnet.org/xsd/adlcp_v1p3 adlcp_v1p3.xsd">
  <metadata>
    <schema>ADL SCORM</schema>
    <schemaversion>1.2</schemaversion>
  </metadata>
  <organizations default="Eleda">
    <organization identifier="Eleda">
      <title>${name}</title>
      <item identifier="eleda" identifierref="res1">
        <title>${name}</title>
      </item>
    </organization>
  </organizations>
  <resources>
    <resource identifier="res1" type="webcontent" adlcp:scormtype="sco" href="index.html">
      <file href="index.html"/>
    </resource>
  </resources>
</manifest>`;
}
